import React from 'react';
import './message.css';
import { inject, observer } from 'mobx-react';
import { messageTypes } from '../../helper/enums';

const Message = inject('RootStore')(observer(({ RootStore }) => {

    const store = RootStore.messageStore;

    let timeOut;

    const getIconClass = () => {
        switch(store.messageType){
            case messageTypes.error: return "exclamation";
            case messageTypes.success: return "check";
            case messageTypes.information: return "info";
            default: return "exclamation";
        }
    }

    const renderMessage = () => {
        if (store.getShowMessage) {
            timeOut = setTimeout(() => store.changeShowMessage(false), 5000);
            return <div className={`system-message system-${store.messageType}-message`}>
                <div className={`system-${store.messageType}-message-first-section`}>
                    <i className={`fas fa-${getIconClass()}`}></i>
                </div>
                <button className="system-message-text">
                    {store.messageText}
                </button>
                <div className="system-message-last-section">
                    <i onClick={onClickHideMessage} className="fas fa-times system-message-icon"></i>
                </div>
            </div>
        }
    }

    const onClickHideMessage = () => {
        store.changeShowMessage(false);
        if (timeOut !== undefined) {
            clearTimeout(timeOut);
        }
    }

    return <>
        {store.getShowMessage ? renderMessage() : null}
    </>
}))

export default Message;